import React, { useState } from "react";
import styled from "styled-components";
import Chatbot from "react-chatbot-kit";
import { BsFillChatRightTextFill } from "react-icons/bs";
import "react-chatbot-kit/build/main.css";
import config from "./config";
import ActionProvider from "./ActionProvider";
import MessageParser from "./MessageParser";

const Chatbotkit = () => {
  const [showChat, setShowChat] = useState(false);
  return (
    <ChatbotContainer>
      {showChat ? (
        <ChatBox>
          <Chatbot
            config={config}
            actionProvider={ActionProvider}
            messageParser={MessageParser}
          />
        </ChatBox>
      ) : null}
      <ChatBtn onClick={() => setShowChat(!showChat)}>
        <BsFillChatRightTextFill className="icon" />
      </ChatBtn>
    </ChatbotContainer>
  );
};

export default Chatbotkit;

const ChatbotContainer = styled.div`
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const ChatBox = styled.div`
  position: fixed;
  top: 12%;
  right: 3%;
  z-index: 10000000;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);

  .react-chatbot-kit-chat-container {
    width: 310px;
  }
  .react-chatbot-kit-chat-header {
    background-color: #fff;
    border-bottom: 2px solid rgb(58, 170, 53);
  }
  .react-chatbot-kit-chat-message-container {
    overflow-x: hidden;
    ::-webkit-scrollbar {
      width: 3px;
    }
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px grey;
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
      background: rgb(32, 32, 79);
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: rgb(32, 32, 79);
    }
  }
  .react-chatbot-kit-chat-bot-message-container {
  }
  .react-chatbot-kit-chat-bot-message {
    width: 230px;
  }

  @media only screen and (max-width: 820px) {
    position: fixed;
    top: 48%;
    right: 3.5%;
  }
  @media only screen and (max-width: 768px) {
    position: fixed;
    top: 41.5%;
    right: 3.5%;
  }
  @media only screen and (max-width: 414px) {
    position: fixed;
    top: 35%;
    right: 4%;
  }
  @media only screen and (max-width: 393px) {
    position: fixed;
    top: 32%;
    right: 3.5%;
  }
  @media only screen and (max-width: 375px) {
    position: fixed;
    top: 16.7%;
    right: 3.5%;
  }
  @media only screen and (max-width: 360px) {
    position: fixed;
    top: 24%;
    right: 3.5%;
  }
`;

const ChatBtn = styled.div`
  position: fixed;
  top: 89%;
  right: 1.7%;
  z-index: 1000000000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: rgb(58, 170, 53);
  border-radius: 50%;
  cursor: pointer;

  .icon {
    font-size: 22.5px;
    color: #fff;
  }
`;
